import { Component, h, Host, Prop } from '@stencil/core';
import { Unsubscribe } from 'redux';
import { RootState } from '../../redux/reducers';
import { store } from '../../redux/store';
import { RtrError, Translations } from '../../redux/types';
import { removeError } from '../../redux/actions';

@Component({
  tag: 'rtr-errors',
  shadow: false,
  styleUrl: 'style.sass',
})
export class RtrErrors {
  @Prop({ mutable: true }) errors: RtrError[] = [];
  @Prop({ mutable: true }) locale: string;
  @Prop({ mutable: true }) translations: Translations;

  removeError!: typeof removeError;
  unsubscribe!: Unsubscribe;

  removeTimeout = 10000;
  componentWillLoad() {
    this.unsubscribe = store.mapStateToProps(this, (state: RootState) => {
      return {
        errors: state.errors,
        locale: state.app.locale,
        translations: state.system.translations,
      };
    });

    store.mapDispatchToProps(this, {
      removeError,
    });
  }

  disconnectedCallback() {
    this.unsubscribe();
  }

  render() {
    return (
      <Host class="RtrErrorsContainer">
        {this.errors.map((err: RtrError, index: number) => {
          const position: string = index * 80 + 'px';

          return (
            <rtr-single-error
              error={err}
              index={index}
              key={err.message + err.type}
              locale={this.locale}
              translations={this.translations}
              class="RtrErrorContainer"
              style={{ bottom: position }}
            />
          );
        })}
      </Host>
    );
  }
}
